/**
 * Sanitize `returnTo` query values for in-app navigation only.
 *
 * WHAT: Rejects absolute URLs and protocol-relative paths before React Router navigate().
 * WHY: Prevents open-redirect if a crafted `/carestart/:slug?returnTo=...` link is shared.
 * INVARIANT: Only paths starting with a single `/` (no `//`) are accepted.
 */

/**
 * @param {string|null|undefined} raw — value from ?returnTo= query param
 * @returns {string|null} Safe relative path, or null if invalid
 */
export function sanitizeInAppReturnPath(raw) {
  if (typeof raw !== 'string') return null;
  const path = raw.trim();
  if (!path.startsWith('/') || path.startsWith('//')) return null;
  if (path.includes('://') || path.includes('\\')) return null;
  return path;
}

const careStartReturnPathUtils = { sanitizeInAppReturnPath };
export default careStartReturnPathUtils;
